// extracted by mini-css-extract-plugin
export default {"icon":"icon_icon__nyKHz","primary":"icon_primary__kzrNz","alert":"icon_alert__yrmIZ","default":"icon_default__In07b"};